const doc = [({"da":({"js":({"shared":({"preview":({"index":({"unknown_type":"Ukendt type"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;